<template>
  <v-container>
    <v-row>
      <v-col class="d-flex flex-column justify-center align-center text-center">
        <v-img
          class="mt-16 mb-8"
          max-width="150px"
          max-height="150px"
          src="../assets/Images/profile-pic (11).png"
        ></v-img>
        <h2>WASEY HASAN KHAN</h2>
        <h3>A Front-end Web Developer</h3>
        <p>&copy; WaseyHasanKhan, 2022 <strong>♾</strong></p>
        <br />
        Made with 💝 and Vue
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 24px;
  font-weight: 600;
  color: #4a171e;
}
h3 {
  font-weight: 400;
  color: #4a171e;
}
p {
  // color: #4a171e;
}
</style>
